import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, CheckIcon, AlertTriangleIcon, GiftIcon } from 'lucide-react';
export const FreeTipsSection: React.FC = () => {
  return <section className="py-12 md:py-20 bg-black overflow-hidden" data-id="element-435">
      <div className="container mx-auto px-4 relative" data-id="element-436">
        {/* Ambient background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-64 bg-green-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-437" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative max-w-4xl mx-auto" data-id="element-438">
          {/* Gradient Border Wrapper */}
          <div className="absolute -inset-[1px] bg-gradient-to-br from-green-300/40 via-green-600/20 to-green-900/40 rounded-2xl blur-[1px]" data-id="element-439" />

          <div className="relative bg-gradient-to-br from-slate-950 via-black to-slate-950 rounded-2xl p-6 sm:p-8 md:p-12 flex flex-col md:flex-row items-center gap-6 md:gap-16 shadow-2xl shadow-green-900/10 border border-white/5" data-id="element-440">
            {/* Left side - Premium Icon */}
            <div className="flex-shrink-0 relative group transform scale-90 md:scale-100" data-id="element-441">
              <div className="absolute inset-0 bg-green-500/20 blur-xl rounded-full group-hover:bg-green-500/30 transition-all duration-500" data-id="element-442" />
              <div className="relative w-28 h-28 md:w-32 md:h-32 rounded-full flex items-center justify-center bg-gradient-to-br from-slate-900 to-black border border-green-500/30 shadow-inner shadow-green-500/10" data-id="element-443">
                <FileTextIcon className="w-12 h-12 md:w-14 md:h-14 text-green-400 drop-shadow-[0_0_10px_rgba(74,222,128,0.3)]" strokeWidth={1.5} data-id="element-444" />
              </div>
              <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-green-600 to-green-500 text-black text-[10px] tracking-widest font-bold px-4 py-1.5 rounded-full shadow-lg shadow-green-900/50 uppercase border border-green-400/50" data-id="element-445">
                Zdarma
              </div>
            </div>

            {/* Right side - Content */}
            <div className="flex-1 text-center md:text-left" data-id="element-446">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 md:mb-6 tracking-tight" data-id="element-447">
                <span className="bg-clip-text text-transparent bg-gradient-to-r from-green-200 via-green-400 to-green-600 drop-shadow-sm" data-id="element-448">
                  ZÍSKEJ ZDARMA
                </span>{' '}
                <span className="text-white block mt-1" data-id="element-449">
                  TIPY PRO RYCHLEJŠÍ PROGRESS
                </span>
              </h2>

              <p className="text-slate-400 mb-6 md:mb-8 leading-relaxed font-light text-sm sm:text-base md:text-lg" data-id="element-450">
                Chceš se dozvědět tajemství, která mohou dramaticky zrychlit
                tvůj progress? Připravil jsem PDF plné tipů a rad, které ti
                pomohou posunout tvůj trénink a výsledky na další úroveň.
              </p>

              <div className="space-y-3 md:space-y-4 mb-8 md:mb-10 text-left" data-id="element-451">
                <div className="flex items-start gap-3 md:gap-4 text-slate-300 group" data-id="element-452">
                  <div className="p-1 rounded-full bg-green-500/10 border border-green-500/20 mt-0.5 group-hover:border-green-500/40 transition-colors flex-shrink-0" data-id="element-453">
                    <CheckIcon className="w-3.5 h-3.5 md:w-4 md:h-4 text-green-400" data-id="element-454" />
                  </div>
                  <span className="font-light text-sm sm:text-base" data-id="element-455">
                    Tajné tipy pro maximální efektivitu tréninku
                  </span>
                </div>
                <div className="flex items-start gap-3 md:gap-4 text-slate-300 group" data-id="element-456">
                  <div className="p-1 rounded-full bg-green-500/10 border border-green-500/20 mt-0.5 group-hover:border-green-500/40 transition-colors flex-shrink-0" data-id="element-457">
                    <AlertTriangleIcon className="w-3.5 h-3.5 md:w-4 md:h-4 text-green-500" data-id="element-458" />
                  </div>
                  <span className="font-light text-sm sm:text-base" data-id="element-459">
                    Nejčastější chyby, které brzdí tvůj progress
                  </span>
                </div>
                <div className="flex items-start gap-3 md:gap-4 text-slate-300 group" data-id="element-460">
                  <div className="p-1 rounded-full bg-green-500/10 border border-green-500/20 mt-0.5 group-hover:border-green-500/40 transition-colors flex-shrink-0" data-id="element-461">
                    <GiftIcon className="w-3.5 h-3.5 md:w-4 md:h-4 text-green-400" data-id="element-462" />
                  </div>
                  <span className="font-light text-sm sm:text-base" data-id="element-463">
                    2 bonusové rady které mně pomohly s rapidním růstem
                  </span>
                </div>
              </div>

              <a href="https://buy.stripe.com/fZu3cucIH7LY6wt2vAg7e03" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto" data-id="element-464">
                <motion.button whileHover={{
                scale: 1.02,
                boxShadow: '0 20px 40px -10px rgba(34, 197, 94, 0.3)'
              }} whileTap={{
                scale: 0.98
              }} className="w-full md:w-auto relative group overflow-hidden bg-gradient-to-r from-green-600 via-green-500 to-green-600 bg-[length:200%_auto] hover:bg-[position:right_center] text-black font-bold py-3 md:py-4 px-8 md:px-10 rounded-xl transition-all duration-500 shadow-xl shadow-green-900/20 border border-green-400/50" data-id="element-465">
                  <span className="relative z-10 tracking-wider text-sm md:text-base" data-id="element-466">
                    MÁM ZÁJEM!
                  </span>
                  <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-500 skew-y-12" data-id="element-467" />
                </motion.button>
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};